module.exports = __webpack_public_path__ + "img/antes_despues_111.14477e59.png";